import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/smartID/tekre_img_01.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={777}
              height={509}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2>
              The <span style={{ color: "#2F55C4" }}>Introduction</span>
            </h2>
            <p>
              We teamed up with the client and helped him create the SmartID,
              Our team worked hard to ensure that the app we create promises a
              quick, uncomplicated and secure experience that would
              revolutionize the way people connect.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
